/* The work. Replaces thingsData as the collection the gallery and the
   detail page read from. Everything else about those components stays.
   Generated from the lukeabc.com v1 project pages. */

/* The Letters archive is counted from the manifest the header already loads,
   so the number in the copy can never fall out of step with the folder. */
const letterCount = () => {
  const sets = (typeof window !== 'undefined' && window.LETTERS) || {};
  return Object.keys(sets).reduce((n, k) => n + (sets[k] || []).length, 0);
};

/* Art of the Run: every run is two files, the piece on its own and the same
   piece with the data grid over it. Add a run by adding its name here and
   dropping the two jpgs into projects/art of running/. */
const AOR_RUNS = [
  '01-afternoon-run-10',
  '02-afternoon-run-11',
  '03-afternoon-run-12',
  '04-afternoon-run-7',
  '05-afternoon-run-8',
  '06-afternoon-run-9',
  '07-evening-run-3',
  '08-evening-run-4',
  '09-evening-run-5',
  '10-lunch-run-1',
  '11-lunch-run-2',
  '12-morning-run-4',
  '13-morning-run-5',
];

const AOR_PIECES = AOR_RUNS.reduce((out, run) => out.concat(
  { type: 'img', src: run + '.jpg' },
  { type: 'img', src: run + '-grid.jpg' },
), []);

const lettersLine = () => {
  const n = letterCount();
  return 'It runs live as the wordmark at the top of this site, each letter cycling '
    + 'through its own set on its own timer, so the logo is never the same twice. '
    + (n ? n + ' letters so far. ' : '') + 'In progress.';
};

const PROJECTS = [
  {
    slug: 'letters',
    title: 'Seven Letters',
    subtitle: 'LUKEABC, found',
    overview: [
      "Seven Letters is a personal brand identity that uses typography from things in pop culture that I like. It's intentionally rough and ready, so when I see a piece of typography that's an L, U, K, E, A, B or C, I screenshot it, drop it into my folder, and the system I've built implements it.",
      lettersLine(),
    ],
    credits: [['Art Direction, Design', 'Lukeabc']],
    discipline: 'Art Direction, Design',
    hero: 'tile.jpg',
    media: [
      { type: 'letters' },
      { type: 'letterprint' },
    ],
  },
  {
    slug: 'art of running',
    title: 'The Art of Running',
    subtitle: 'Every run as a one-of-one',
    overview: [
      'Art Of The Run is a durational art project in which every run I do becomes a generative artwork.',
      'Each run is recorded on my watch and synced to Strava, then downloaded as a .gpx file, a plain text record of the run: where I went, how fast, my heart rate, the elevation, the time of day. That file is fed into a custom rendering engine built for the project, which composes the piece in layers and processes it through GPU shader and pixel-level treatments, with satellite imagery of the route worked into the surface. Once the run is done, the piece is generated without further intervention.',
      'The visual language of the system was art-directed through conversation, in text and voice, before the project was implemented. This gave more direct control over developing and iterating the aesthetic than tools like Photoshop.',
    ],
    credits: [['Art Direction, Code, Design', 'Lukeabc']],
    discipline: 'Art Direction, Code, Design',
    /* the live page sits outside the app as its own file, so this is a plain
       relative path rather than a route */
    links: [
      { label: 'Open the engine', href: 'run/' },
    ],
    hero: 'example.jpg',
    media: [
      {
        type: 'text',
        paras: [
          'Each work is built on a grid, one cell per kilometre run, so the distance sets the structure. A 10km run makes a 10-cell piece.',
          "Every kilometre introduces a shape and a colour. The shape is drawn from that kilometre's pace, softer when slow, sharper when fast. The colours are picked per run from a fixed palette, one unlocked for each kilometre covered. Kilometres run at a higher heart rate carry a heat signature, scorching and glowing where the effort was hardest. The route is revealed through the surface in satellite imagery, the run's own line acting as the brush.",
          'The whole composition is then melted. The pace of the run sets how heavily it melts, and the wave of the melt is unique to each run, so no two pieces distort the same way. The temperature on the day shifts the colour of the finished piece, more vivid in heat, inverted below freezing.',
          'Pieces are shown two ways: clean, and with the grid visible, where the data from the run is laid over the work kilometre by kilometre.',
        ],
      },
      ...AOR_PIECES,
    ],
  },
  {
    slug: 'gameweek',
    title: 'GAMEWEEK',
    subtitle: 'A card for every gameweek',
    overview: [
      'A self-initiated challenge to make a sports card for every gameweek of the 2026/27 Premier League season. In progress.',
    ],
    credits: [['Art Direction, Copywriting, Design', 'Lukeabc']],
    discipline: 'Art Direction, Copywriting, Design',
    hero: 'tile.jpg',
    // shot in the toploader, front then back, card by card
    media: [
      { type: 'img', src: 'gw1-front.jpg' },
      { type: 'img', src: 'gw1-back.jpg' },
      { type: 'img', src: 'gw2-front.jpg' },
      { type: 'img', src: 'gw2-back.jpg' },
      { type: 'img', src: 'gw3-front.jpg' },
      { type: 'img', src: 'gw3-back.jpg' },
    ],
  },
  {
    slug: 'my pc',
    title: 'My PC',
    subtitle: 'The computer I built as a kid, rebuilt in a browser',
    overview: [
      'An experiment creating an immersive web experience that replicates the aesthetic of a childhood desktop, made by combining a load of different repos and effects and art directing them into one thing.',
    ],
    credits: [['Art Direction, Code, Design', 'Lukeabc']],
    discipline: 'Art Direction, Code, Design',
    /* the machine is its own build, sitting inside the site next to run/, so
       this is a plain relative path like Art of the Run's engine */
    links: [
      { label: 'Switch it on', href: 'my-pc/' },
    ],
    /* The grid tile is the piece — a screenshot of the desktop itself. Showing
       it again on the page rather than a second, different picture, so the
       thing you clicked is the thing you land on. */
    hero: 'tile.jpg',
    media: [
      { type: 'img', src: 'tile.jpg' },
    ],
  },
  {
    slug: 'surf and chill',
    title: 'Surf and Chill',
    subtitle: 'Ambient YouTube through a CRT',
    overview: [
      'Ambient YouTube through a CRT. Scanlines, aperture grille, bloom, vignette, a rolling refresh bar, mains flicker and glass reflection, all layered over a live embed so the picture stays interactive underneath.',
      'One file, no build step. In progress.',
    ],
    credits: [['Art Direction, Code, Design', 'Lukeabc']],
    discipline: 'Art Direction, Code, Design',
    hero: 'mg2.png',
    media: [
      { type: 'img', src: 'still.jpg' },
    ],
  },
  {
    slug: 'bills computer',
    title: 'Bill\'s Computer',
    subtitle: 'A Pokémon trainer\'s desktop OS in the browser',
    overview: [
      "Named after Bill's PC in the original Red and Blue on Game Boy, Bill's Computer is a desktop operating system in the browser for organising a Pokémon card collection. One of my first goes at building with Claude Code and Codex, plugged into card data and APIs that already existed rather than anything I invented.",
    ],
    credits: [['Art Direction, Code, Design', 'Lukeabc']],
    discipline: 'Art Direction, Code, Design',
    links: [
      { label: 'View project', href: 'https://bills.computer' },
    ],
    hero: 'tile.jpg',
    media: [
      { type: 'img', src: 'pic1.jpg' },
      { type: 'img', src: 'pic4.jpg' },
      { type: 'img', src: 'pic2.jpg' },
      { type: 'img', src: 'pic3.jpg' },
    ],
  },
  {
    slug: 'doofer',
    title: 'Doofer',
    /* kept in the data, and still reachable at its own address, but left out
       of the grid, the list and the desktop until it's ready to show */
    hidden: true,
    subtitle: 'Web-based IPTV Player',
    overview: [
      'A web-based IPTV player built so I could watch football in VR. Couldn\'t find one that worked, so I built one with Claude Code. Load an M3U playlist, pick a channel, watch. There\'s a Windows skin too, for when the football\'s on and you\'re not meant to be watching it.',
    ],
    credits: [['Art Direction, Code, Design', 'Lukeabc']],
    discipline: 'Art Direction, Code, Design',
    links: [
      { label: 'View project', href: 'http://doofertv.crof.co.uk' },
    ],
    hero: 'work2.jpg',
    media: [
      { type: 'img', src: 'work.jpg' },
    ],
  },
  {
    slug: 'orb',
    title: 'The Orb Project',
    subtitle: 'The sun and moon, as light and sound',
    overview: [
      'Inspired by Olafur Eliasson\'s The Weather Project. A glowing orb whose colour, brightness and sound are driven by the real sun and moon above you, calculated from your location and clock. Built in the browser with WebGL and Web Audio.',
    ],
    credits: [['Art, Code', 'Lukeabc']],
    discipline: 'Art, Code',
    links: [
      { label: 'View project', href: 'https://the-orb-project.vercel.app/' },
    ],
    hero: 'tile.jpg',
    media: [
      { type: 'img', src: 'hero.jpg' },
    ],
  },
  {
    slug: 'sticker',
    title: 'Got, Got, Need',
    subtitle: 'World Cup 2026 Digital Collectibles',
    overview: [
      "When I saw what it cost to complete Panini's official FIFA World Cup 2026 sticker book, I decided to make my own.",
      'Got, Got, Need is a digital sticker book where you collect players by dragging images from Google Images into an album. You open packs to get assigned players, then go and find the photos yourself.',
      'It uses a few of the official brand assets, but everything else was designed in my own style and art direction.',
    ],
    credits: [['Design, Code', 'Lukeabc']],
    discipline: 'Design, Code',
    links: [
      { label: 'View project', href: 'https://sticker-book-pi.vercel.app/' },
    ],
    hero: 'front-cover.jpg',
    media: [
      { type: 'img', src: 'back-cover.jpg' },
      { type: 'img', src: 'pack.jpg' },
      { type: 'img', src: 'sticker-template_rare.png' },
      { type: 'img', src: 'sticker-template_moment.png' },
      { type: 'img', src: 'scotland_collage.jpg' },
    ],
  },
  {
    slug: 'btc.art',
    title: 'BTC.ART',
    subtitle: 'Brand Identity',
    overview: [
      'Brand identity for BTC.ART, the home of curated art on Bitcoin. The identity bridges two worlds: the systematic, deterministic nature of blockchain technology and the expressive energy of contemporary digital art.',
      'The wordmark is set in a pixel typeface and rendered in a spectrum gradient.',
    ],
    credits: [['Art Direction, Design', 'Lukeabc']],
    discipline: 'Art Direction, Design',
    hero: 'tile.jpg',
    media: [
      { type: 'img', src: 'var-gradient-light.jpg' },
      { type: 'img', src: 'var-gradient-dark.jpg' },
      { type: 'img', src: 'var-mono-white.jpg' },
      { type: 'img', src: 'var-mono-black.jpg' },
    ],
  },
  {
    slug: 'ogs',
    title: 'The OGs',
    subtitle: 'Brand Identity',
    overview: [
      'Brand identity for The OGs, a series of 1,024 digital paintings by FAR that reimagine emojis as painterly digital relics. Each work begins as a hand-drawn emoji, then gets rebuilt through algorithms that distort, warp and layer it into something between painting and code.',
      'The project name is a play on OGs and em-O-gees, so the identity needed to live in that same space: familiar symbols, remixed beyond recognition.',
    ],
    credits: [['Art Direction, Design', 'Lukeabc']],
    year: '2025',
    discipline: 'Art Direction, Design',
    hero: 'tile.jpg',
    media: [
      { type: 'img', src: 'ogs-1.gif' },
      { type: 'img', src: 'og1.jpg' },
      { type: 'img', src: 'og5.jpg' },
      { type: 'img', src: 'og4.jpg' },
      { type: 'img', src: 'ogstest.gif' },
      { type: 'img', src: 'fabbb1a7e9b6085e85dd8e3db54a8ca7.avif' },
      { type: 'img', src: 'ded7e5628b66cd421c394223ad5b9dfe.avif' },
      { type: 'img', src: '837e8895a99c69d53c8225f728d6b46f.avif' },
      { type: 'img', src: '426103eb884eb9acf0371141ea5b1803.avif' },
    ],
  },
  {
    slug: 'paralax',
    title: 'FAR',
    subtitle: 'Visual Identity',
    overview: [
      'A visual identity system for artist Francisco Alarcón (FAR), whose practice spans multiple collections, each with its own visual language, material, and register. The challenge was to create a single identity framework that could hold them all together without flattening what made each one distinct.',
      'The system needed to work across collections that already existed and be open enough that new additions could slot in using the same process.',
    ],
    credits: [['Art Direction, Design', 'Lukeabc'], ['Artist', 'Francisco Alarcón (FAR)']],
    year: '2024',
    discipline: 'Art Direction, Design',
    hero: 'tile.jpg',
    media: [
      { type: 'img', src: 'hero.jpg' },
      { type: 'img', src: 'blank1.jpg' },
      { type: 'img', src: 'blank2.jpg' },
      { type: 'img', src: 'blank3.jpg' },
      { type: 'img', src: 'blank4.jpg' },
      { type: 'img', src: 'blank5.jpg' },
      { type: 'img', src: 'blank6.jpg' },
      { type: 'img', src: 'untitled-0.jpg' },
      { type: 'img', src: 'Untitled-3.jpg' },
      { type: 'img', src: 'Untitled-4.jpg' },
      { type: 'img', src: 'Untitled-5.jpg' },
      { type: 'img', src: 'Untitled-6.jpg' },
      { type: 'img', src: 'Untitled-7.jpg' },
    ],
  },
  {
    slug: 'lobsters',
    title: 'Lobsters',
    subtitle: 'A scripted comedy set inside a fictional radio station',
    overview: [
      'Pilot episode for a scripted audio comedy set inside a fictional radio station, following the presenters who work the lobster shift, the overnight slot nobody listens to.',
    ],
    credits: [['Creative Direction', 'Lukeabc'], ['Writing, Production', 'B-Love, Mr. Q']],
    year: '2023',
    discipline: 'Creative Direction',
    hero: 'tile.jpg',
    media: [
      { type: 'video', src: 'https://www.youtube-nocookie.com/embed/RdOLbXiUQTg?rel=0&modestbranding=1&showinfo=0' },
    ],
  },
  {
    slug: 'hbr',
    title: 'If You Look Hard Enough',
    subtitle: 'Commissioned for Harvard Business Review',
    overview: [
      'Commissioned by Harvard Business Review to accompany Why Build in Web3, an article by Jad Esber and Scott Duke Kominers on the case for open, user-owned platforms.',
    ],
    credits: [['Art', 'Lukeabc']],
    discipline: 'Art',
    links: [
      { label: 'Why Build in Web3, Harvard Business Review', href: 'https://hbr.org/2022/05/why-build-in-web3' },
    ],
    hero: 'ifyoulookhardenough.jpg',
    media: [
    ],
  },
  {
    slug: 'goal',
    title: 'This Is Everything',
    subtitle: 'Brand Platform',
    overview: [
      'A brand manifesto and identity refresh for GOAL, the global football media platform. Produced through VICE Media Copenhagen, the brief called for a new voice, visual direction, and narrative framework that could carry the brand forward.',
      'The project led directly to a full-time position at Footballco, where I went on to build editorial frameworks, social formats, and long-form storytelling systems.',
    ],
    credits: [['Art Direction, Copywriting', 'Lukeabc'], ['Creative Direction', 'Rich Perusi'], ['Agency', 'VICE Media Copenhagen']],
    year: '2021',
    discipline: 'Art Direction, Copywriting',
    hero: 'tile.jpg',
    media: [
      { type: 'img', src: 'goal1.jpg' },
      { type: 'img', src: 'goal2.jpg' },
      { type: 'img', src: 'goal3.jpg' },
      { type: 'img', src: 'goal4.jpg' },
      { type: 'img', src: 'goal5.jpg' },
      { type: 'img', src: 'goal6.jpg' },
      { type: 'img', src: 'goal7.jpg' },
      { type: 'img', src: 'goal8.jpg' },
      { type: 'img', src: 'goal9.jpg' },
    ],
  },
  {
    slug: 'thingdoms',
    title: 'Thingdoms',
    subtitle: 'A generative character project',
    overview: [
      'Thingdoms is an experimental art project released in 2021 as a complete collection of 10,000 digital characters called Things. I created the character and drew every trait by hand, then my friend Eoghan wrote the code that combined them into the collection. It explores identity, mood, and narrative through character-based generative systems.',
      'Conceived as a kind of Gesamtkunstwerk, it emerged during a moment shaped by generative art, blockchain, and internet culture, and lives across various mediums.',
    ],
    credits: [['Art, Creative Direction', 'Lukeabc'], ['Code', 'Eoghan']],
    discipline: 'Art, Creative Direction',
    hero: 'remaster/125.jpg',
    media: [
      { type: 'things' },
    ],
  },
  {
    slug: 'nike',
    title: 'Speed You Can\'t Catch',
    subtitle: 'Campaign',
    overview: [
      'Launch campaign for Nike\'s latest Mercurial boots, featuring Ronaldo, Mbappé, and Neymar. A series of sharp, social-first films I worked on at AKQA London for the Nike Football account.',
    ],
    credits: [['Copywriting', 'Lukeabc'], ['Creative Direction', 'Adrian Stannard'], ['Design / Art Direction', 'Barry Slater'], ['Agency', 'AKQA London']],
    discipline: 'Copywriting',
    hero: 'tile.jpg',
    media: [
      { type: 'img', src: 'nike-ronaldo.jpg' },
      { type: 'video', src: 'https://player.vimeo.com/video/394155156?title=0&byline=0&portrait=0' },
      { type: 'img', src: 'nike-mbappe.jpg' },
      { type: 'video', src: 'https://player.vimeo.com/video/394155190?title=0&byline=0&portrait=0' },
      { type: 'img', src: 'nike-neymar.jpg' },
      { type: 'video', src: 'https://player.vimeo.com/video/394154938?title=0&byline=0&portrait=0' },
    ],
  },
  {
    slug: 'voco',
    title: 'Stay Interesting',
    subtitle: 'Brand Platform',
    overview: [
      'Voco is an IHG hotel brand built on conversion. They find interesting independent hotels and rebrand them. Every property is different, but they all need to feel like Voco. The job was to define a comms system that could highlight what makes each hotel individual while holding everything together under one voice.',
      'The approach: dig into each location, find something worth talking about, and build the communication around that. Not a single campaign but a way of working, a system flexible enough to roll out globally, one hotel at a time, across print, digital, content and in-property collateral.',
      'The visual language uses abstract patterns cut from cross-sections of the Voco logo, giving the brand a consistent graphic texture that runs through everything from press ads to hotel signage.',
    ],
    credits: [['Creative', 'Lukeabc, Elliot Shiels'], ['Creative Direction', 'Mike Watson'], ['Agency', 'JWT London']],
    year: '2019',
    discipline: 'Art Direction, Copywriting',
    hero: 'tile.jpg',
    media: [
      { type: 'img', src: 'voco1.jpg' },
      { type: 'img', src: 'voco2.jpg' },
      { type: 'img', src: 'voco3.jpg' },
      { type: 'img', src: 'voco4.jpg' },
      { type: 'img', src: 'voco5.jpg' },
      { type: 'img', src: 'voco6.jpg' },
      { type: 'img', src: 'voco7.jpg' },
    ],
  },
  {
    slug: 'dazn',
    title: 'Raw Sport',
    subtitle: 'Brand Platform',
    overview: [
      'Global platform launch for DAZN, the sports streaming service. The brief was to establish the brand around a single idea, Raw Sport, and roll it out across every touchpoint: broadcast idents, fight promos, social content, and outdoor campaigns in markets worldwide.',
      'Part of a core creative team at Dentsu McGarryBowen, I worked across concept, art direction, and copy, helping define the visual language and editorial tone that gave the platform its identity.',
    ],
    credits: [['Art Direction, Copywriting', 'Lukeabc'], ['Creative Direction', 'Angus Macadam, Joe Koprowski'], ['Creative Direction (DAZN)', 'Toby, Stu'], ['Agency', 'Dentsu McGarryBowen']],
    discipline: 'Art Direction, Copywriting',
    hero: 'dazn1.jpg',
    media: [
      { type: 'video', src: 'https://player.vimeo.com/video/514456829?title=0&byline=0&portrait=0' },
      { type: 'img', src: 'dazn5.jpg' },
      { type: 'video', src: 'https://player.vimeo.com/video/467675464?title=0&byline=0&portrait=0' },
      { type: 'img', src: 'dazn4.gif' },
      { type: 'video', src: 'https://player.vimeo.com/video/468075278?title=0&byline=0&portrait=0' },
      { type: 'img', src: 'dazn7.jpg' },
      { type: 'img', src: 'dazn8.jpg' },
      { type: 'video', src: 'https://player.vimeo.com/video/468111521?title=0&byline=0&portrait=0' },
      { type: 'img', src: 'dazn9.jpg' },
    ],
  },
  {
    slug: 'Samsonite',
    title: 'Samsonite',
    subtitle: 'Behind the scenes content for Samsonite',
    overview: [
      'Directing behind the scenes content for a Samsonite campaign shoot at RANKIN.',
    ],
    credits: [['Direction', 'Lukeabc'], ['Agency', 'RANKIN / The Full Service']],
    discipline: 'Direction',
    hero: 'tile.jpg',
    media: [
      { type: 'video', src: 'https://player.vimeo.com/video/233309882?title=0&byline=0&portrait=0' },
    ],
  },
  {
    slug: 'skaters',
    title: 'Rock and Roll Bye Bye',
    subtitle: 'A music video and tour content for SKATERS',
    overview: [
      'A music video and tour content package for NYC band SKATERS. I joined the UK tour as a one-person crew, directing, shooting, and editing everything on the road. The video premiered on NOISEY.',
    ],
    credits: [['Art Direction, Direction', 'Lukeabc'], ['Artist', 'SKATERS'], ['Premiered', 'NOISEY'], ['Production', 'Independent']],
    discipline: 'Art Direction, Direction',
    links: [
      { label: 'Premiere on NOISEY', href: 'https://www.vice.com/en/article/premiere-skaters-video-rock-n-roll-bye-bye/' },
    ],
    hero: 'skaters1.jpg',
    media: [
      { type: 'video', src: 'https://www.youtube-nocookie.com/embed/NcwnCmAcMzs?rel=0&modestbranding=1&showinfo=0' },
      { type: 'video', src: 'https://www.youtube-nocookie.com/embed/dMoOVks3Lz4?rel=0&modestbranding=1&showinfo=0' },
    ],
  },
  {
    slug: 'kanye',
    title: 'Things and Stuff',
    subtitle: 'Lo-fi tweet archive, photocopied & hand-bound in NYC',
    overview: [
      'A lo-fi zine archiving Kanye West\'s tweets from January to March 2016, right around the Life of Pablo rollout. Photocopied, hand-bound with pink thread, and produced in a single run.',
      'Made at 8 Ball Community, an artist collective operating out of a basement in Soho, NYC. Part zine library, part radio station, part public access studio. A space where anyone could walk in, use the tools, and publish something. I was living in New York at the time and started making zines to learn the form and contribute to the collective\'s output.',
      'Collected and printed, the tweets become an accidental time capsule of a specific moment in internet culture.',
    ],
    credits: [['Art Direction, Curation, Design', 'Lukeabc'], ['Produced at', '8 Ball Community, NYC']],
    year: '2016',
    discipline: 'Art Direction, Curation, Design',
    hero: 'tile.jpg',
    media: [
      { type: 'img', src: 'k1.jpeg' },
      { type: 'img', src: 'k2.jpeg' },
      { type: 'img', src: 'k3.jpeg' },
      { type: 'img', src: 'k4.jpeg' },
      { type: 'img', src: 'k5.jpeg' },
    ],
  },
  {
    slug: 'honda',
    title: 'Perfect Fit Garage',
    subtitle: 'Campaign',
    overview: [
      'A social-first pre-launch campaign for the Honda HR-V, built around a single observation: nobody actually parks in their garage. It\'s full of everything else.',
      'The brief positioned the HR-V as a car that fits into your life. We took that literally, and made the mess the message.',
    ],
    credits: [['Art Direction', 'Lukeabc'], ['Copywriting', 'Jenny Hughes'], ['Creative Direction', 'Gav Gordon-Rodgers, Gemma Butler'], ['Agency', 'Lost Boys / DigitasLBi']],
    year: '2015',
    discipline: 'Art Direction',
    links: [
      { label: 'Review on davidreviews', href: 'https://www.davidreviews.com/Reviews/2015/Honda_HRV_Perfect_Fit/' },
    ],
    hero: 'hrv1.avif',
    media: [
      { type: 'video', src: 'https://player.vimeo.com/video/137935203?title=0&byline=0&portrait=0' },
      { type: 'img', src: 'hrv4.avif' },
      { type: 'img', src: 'hrv9.avif' },
    ],
  },
  {
    slug: 'wuthering heights',
    title: 'Little Book',
    subtitle: 'Wuthering Heights in miniature',
    overview: [
      'Made a miniature version of the first chapter of Wuthering Heights at work, on downtime, while testing the agency\'s fancy new printer. Gave it to the designer I fancied. It was her favourite book. We\'re married now.',
    ],
    credits: [['Design', 'Lukeabc']],
    discipline: 'Design',
    hero: 'tile.jpg',
    media: [
      { type: 'img', src: 'wuth.jpg' },
    ],
  },
  {
    slug: 'bjm',
    title: 'Brian Jonestown Massacre',
    subtitle: 'Various tour posters',
    overview: [
      'A series of gig posters designed for Brian Jonestown Massacre\'s 2014 European tour. Each poster takes a completely different visual approach to reflect the character of the city it was made for.',
    ],
    credits: [['Design, Illustration', 'Lukeabc']],
    discipline: 'Design, Illustration',
    hero: 'tile.jpg',
    media: [
      { type: 'img', src: 'amsterdam.jpg' },
      { type: 'img', src: 'malmo.jpg' },
      { type: 'img', src: 'barcelona.jpg' },
      { type: 'img', src: 'paris.jpg' },
    ],
  },
  {
    slug: 'irn-bru',
    title: 'Christmas Card',
    subtitle: 'Christmas Campaign',
    overview: [
      'A Christmas card for the whole of Scotland. Concepted during a placement and later included in IRN-BRU multipacks across the country over Christmas. One of three seasonal cards. First piece of work I ever made that went out into the world.',
    ],
    credits: [['Art Direction', 'Lukeabc'], ['Agency', 'The Leith Agency']],
    discipline: 'Art Direction',
    hero: 'ib-1.jpg',
    media: [
    ],
  },
  {
    slug: 'selected works',
    title: 'Selected Works',
    subtitle: 'Art, Illustration & Type',
    overview: [
      'Personal and experimental work across illustration, hand-lettering, digital painting, file glitching, and graphic art.',
    ],
    credits: [['Art, Illustration', 'Lukeabc']],
    discipline: 'Art, Illustration',
    hero: 'i7.jpeg',
    media: [
      { type: 'img', src: 'i3.jpg' },
      { type: 'img', src: 'i1.jpg' },
      { type: 'img', src: 'i12.jpg' },
      { type: 'img', src: 'i13.jpg' },
      { type: 'img', src: 'tumblr_ma8r9ezzMo1qfwoa1o1_1280.jpg' },
      { type: 'img', src: 'tumblr_ma8rapeXXE1qfwoa1o1_1280.jpg' },
      { type: 'img', src: 'tumblr_ma8rcfJU8X1qfwoa1o1_1280.jpg' },
      { type: 'img', src: '5aafc0acd635973077029af8ce1d5c10.jpg' },
      { type: 'img', src: '46f32cdaba20094c666f16621e60598e.jpg' },
      { type: 'img', src: 'i9.jpg' },
      { type: 'img', src: 'tumblr_o3myxs4hSA1qfwoa1o1_1280.jpg' },
      { type: 'img', src: '33.jpg' },
      { type: 'img', src: 'tpo2.jpg' },
      { type: 'img', src: 'i18.jpg' },
      { type: 'img', src: 'i19.jpg' },
      { type: 'img', src: 'tumblr_nmllpyV0rD1qfwoa1o1_1280.jpg' },
      { type: 'img', src: 'tumblr_npwrfm0r401qfwoa1o3_1280.jpeg' },
      { type: 'img', src: 'tumblr_nqm4jlWprE1qfwoa1o2_1280.jpeg' },
      { type: 'img', src: 'tumblr_nqmhtu3Hkt1qfwoa1o1_500.webp' },
      { type: 'img', src: '78ce37730f790ad6f67b9c5f25ad7420.jpg' },
      { type: 'img', src: 'b2fd31727a2b3aef118f0190ffc78bb9.jpg' },
      { type: 'img', src: '68d50ba29f65b5c526e05d94dbb7619b.jpg' },
      { type: 'img', src: '0cda76287f0deeb41b91b1269cda459c.jpg' },
      { type: 'img', src: '7f10a66b5584edeb6bbc62592661ee0d.jpg' },
      { type: 'img', src: 'a2a5372308d842638aae298078f32f57.jpg' },
      { type: 'img', src: 'aaaf93e367b9c437a9414d8bf047ffad.jpg' },
      { type: 'img', src: '57535526f4486159bafcccc4fcbe1c34.jpg' },
      { type: 'img', src: '649cbb90c11e2ef52f8dabcd0f8e60cc.jpg' },
      { type: 'img', src: 'cab6fa85ff7ebf6d60243d376050e76b.jpg' },
      { type: 'img', src: '97557761453840b4ef8e601f0dffe283.jpg' },
      { type: 'img', src: '22.jpg' },
      { type: 'img', src: '4e9a2ecce8fe5837c61f16700ff73b4c.jpg' },
      { type: 'img', src: '3d2a947b1b31a6777788a4bcf6c80eb4.jpg' },
      { type: 'img', src: 'c87c9088e8978173f52847d4177eda4c.jpg' },
      { type: 'img', src: 'cc492b18b2e1d3d4602a311fcbf7a6c1.jpg' },
      { type: 'img', src: 'tumblr_ng4shgIKQt1qfwoa1o1_1280.jpg' },
      { type: 'img', src: 'tumblr_ng4slwnydJ1qfwoa1o1_1280.jpg' },
      { type: 'img', src: 'tumblr_ng4ssbyIvy1qfwoa1o1_1280.jpg' },
      { type: 'img', src: 'tumblr_ng4sz4jQcb1qfwoa1o1_1280.jpg' },
      { type: 'img', src: 'tumblr_ng4tfif5Xb1qfwoa1o1_1280.jpg' },
      { type: 'img', src: 'tumblr_ngf1ivB1GZ1qfwoa1o1_500.jpg' },
      { type: 'img', src: 'tumblr_nmutvi9muR1qfwoa1o1_1280.jpeg' },
      { type: 'img', src: 'tumblr_nmutvi9muR1qfwoa1o2_1280.jpeg' },
      { type: 'img', src: 'tumblr_nmuurtoYtr1qfwoa1o1_1280.jpg' },
      { type: 'img', src: 'tumblr_nnvdhxMn2t1qfwoa1o1_1280.jpeg' },
      { type: 'img', src: 'tumblr_nnvdjkCnXf1qfwoa1o1_1280.jpeg' },
      { type: 'img', src: 'tumblr_nnxnebtlxI1qfwoa1o1_1280.jpeg' },
      { type: 'img', src: 'tumblr_nnxnf7Chny1qfwoa1o1_1280.jpeg' },
      { type: 'img', src: 'tumblr_nnxngiv2p71qfwoa1o1_640.jpeg' },
      { type: 'img', src: '769d0db8c709e4553ddbc12006697636-23.png' },
    ],
  },
  {
    slug: 'moodboards',
    title: 'Moodboards',
    subtitle: 'Visual Research & Art Direction',
    overview: [
      'Starting points, art direction, visual thinking. Some of these became real projects. Some didn\'t.',
    ],
    credits: [['Art Direction, Curation', 'Lukeabc']],
    discipline: 'Art Direction, Curation',
    hero: 'moodboard1.jpg',
    media: [
      { type: 'img', src: 'moodboard2.jpg' },
      { type: 'img', src: 'moodboard3.jpg' },
      { type: 'img', src: 'moodboard4.jpg' },
      { type: 'img', src: 'moodboard5.jpg' },
      { type: 'img', src: 'moodboard6.jpg' },
      { type: 'img', src: 'moodboard7.jpg' },
      { type: 'img', src: 'moodboard8.jpg' },
      { type: 'img', src: 'moodboard9.jpg' },
      { type: 'img', src: 'moodboard10.jpg' },
      { type: 'img', src: 'moodboard11.jpg' },
      { type: 'img', src: 'moodboard12.jpg' },
      { type: 'img', src: 'moodboard13.jpg' },
      { type: 'img', src: 'moodboard14.jpg' },
    ],
  },
];

export default PROJECTS;

export const TOTAL_PROJECTS = PROJECTS.length;

/* Projects marked hidden stay in the list so their own page still works and
   the numbering doesn't shift, but nothing that enumerates the work shows
   them. */
export const isVisible = (p) => !!p && !p.hidden;
export const VISIBLE_PROJECTS = PROJECTS.filter(isVisible);

/* The running order of the work, used by every view of it.
 *
 * A fixed list, not a shuffle. This is the order Luke chose: Honda first, then
 * GAMEWEEK, The Art of Running and The OGs, then the rest as it stands. The
 * tiles, the list and the index all read it, so a project is in the same place
 * wherever you look at it.
 *
 * Slugs rather than titles, so renaming a project can't drop it out of the
 * order. To move something, move its line. Anything visible but missing from
 * this list still appears, at the end, so a new project is never silently
 * dropped — it just needs adding here to sit where you want it. */
export const ORDER = [
  'honda', 'gameweek', 'art of running',
  'ogs', 'letters', 'kanye',
  'irn-bru', 'nike', 'sticker',
  'Samsonite', 'orb', 'selected works',
  'paralax', 'goal', 'lobsters',
  'hbr', 'voco', 'thingdoms',
  'wuthering heights', 'surf and chill', 'my pc',
  'moodboards', 'dazn', 'bills computer',
  'bjm', 'skaters', 'btc.art',
];

export const ORDERED_PROJECTS = (() => {
  const all = PROJECTS.map((p, i) => ({ p, id: i + 1 })).filter(({ p }) => isVisible(p));
  const listed = ORDER
    .map((slug) => all.find((e) => e.p.slug === slug))
    .filter(Boolean);
  const unlisted = all.filter((e) => !ORDER.includes(e.p.slug));
  return listed.concat(unlisted);
})();

// ids are 1-based so the existing prev/next arrow logic works unchanged
export const getProject = (id) => PROJECTS[parseInt(id, 10) - 1];

/* URLs read as /work/<project name>. The address is made from the title
   rather than the folder slug, so what someone sees in the bar is the name
   they clicked. Folder names stay as they are; nothing on disk moves. */
export const urlSlug = (project) =>
  (project && project.title ? project.title : '')
    .toLowerCase()
    .replace(/['\u2019]/g, '')       // Bill's -> bills
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const projectUrl = (project) => `/work/${urlSlug(project)}`;

/* index is one based, matching the old /things/:id numbering */
export const indexOfProject = (project) => PROJECTS.indexOf(project) + 1;

export const getProjectByUrl = (slug) => {
  if (!slug) return null;
  const want = String(slug).toLowerCase();
  return PROJECTS.find((p) => urlSlug(p) === want) || null;
};

const enc = (s) => s.split('/').map(encodeURIComponent).join('/');

export const projectImageUrl = (project, file) =>
  `projects/${enc(project.slug)}/${enc(file)}`;

export const getProjectHero = (id) => {
  const p = getProject(id);
  return p && p.hero ? projectImageUrl(p, p.hero) : '';
};
